export class DateRange {
    from: Date;
    to: Date;
    tooltip: string;
}


export class DateTimeChartDataItemModel {
    dateTime: Date;
    dateRange?: DateRange;
    value: number;

    constructor(dateTime: Date, value: number, dateRange?: DateRange) {
        this.dateTime = dateTime;
        this.value = value;
        this.dateRange = dateRange;
    }
}
